import React, { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import Helmet from 'react-helmet';
import CabModifySearch from '../../components/CabModifySearch/CabModifySearch';
import WhyBookWithUs from '../../components/WhyBookWithUs/WhyBookWithUs';
import FaqSection from '../../components/Faq/Faq';
import RentalCabPrice from '../../components/RentalCabPrice/RentalCabPrice';
import RentalCabs from '../../components/RentalCabs/RentalCabs';
import ThingsToKnow from '../../components/ThingsToKnow/ThingsToKnow';
import TopCabsRoutes from '../../components/TopCabsRoutes/TopCabsRoutes';
import Footer from '../../components/Footer/Footer';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import PageHeader from '../../components/PageHeader/PageHeader';
import CompactList from '../../components/CompactList/CompactList';
import DataLoaderError from '../../../server/errors/DataLoaderError';
import {
  CityTemplateChecker,
  CityTemplateData
} from './CityTemplateDataChecker';
import '../MultiCityPage/MultiCityPage.css';
import { ThrowReporter } from 'io-ts/lib/ThrowReporter';
import { PathReporter } from 'io-ts/lib/PathReporter';
import { RouteComponentProps } from 'react-router-dom';
// import AdsComponent from '../../components/adsComponent';
import AppContextProvider from '../../AppContext';
import { trackCityTemplateEvent } from '../../../src/utils/omnitureTracking';
import './CityTemplate.css';
import { EnvironmentVariables } from '../../types';
import { getAppEnv } from '../../../config/env';
import Overlay from '../../components/BPG/Overlay';
import { useKnowMoreDetails } from '../customHooks';
import { SEO_CITY_TEMPLATE } from '../../constants/templateConstants';
import AssistModal from '../../components/AssistModal';
import { SCROLL } from '../../constants/miscellaneousConstants';
import {
  detectUserActivity,
  isMobile,
  useSearchWidgetHooks,
  generateRequestId,
  isSEM
} from '../../utils/commonUtils';
import { yeildToMainThread } from '../../scheduler';
import { makeServiceDeskRequest } from '../../cabsAPIs';
import ProductSchema from '../../utils/ProductSchema';
import InboundCallBox from '../../components/InboundCall/InboundCallBox';
import CallUsModal from '../../components/AssistModal/callUsModal';
import TripAssistant from '../TripAssistant';
import MultiCityPackages from '../../components/MultiCityPackages/MultiCityPackages';
// import { packageData } from './PackageInfo';
import PackagesModal from '../../components/PackagesModal/PackagesModal';
import PackagesBottomSheet from '../../components/GenerateBanner/PackagesBottomSheet';
import PackageBanner from '../../components/PackageBanner/PackageBanner';
import { OUTSTATION_ROUND_TRIP } from '../../constants/tripTypes';
// import { logRttEventLogger } from '../../logRttRequestBuilder';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;
const { DATA_LOADER_URL } = env.raw as EnvironmentVariables;
const isSSR = typeof window === 'undefined';
const ASSISTED_FORM_DATA_LS = 'ASSISTED_FORM_DATA_LS';

type PathParamsType = {
  cityCode: string;
};
type CityTemplateProp = RouteComponentProps<PathParamsType> & {
  data: CityTemplateData;
};

const runtimeTypChecker = (data: CityTemplateData) => {
  const result = CityTemplateChecker.decode(data);
  if (result._tag !== 'Right') {
    // console.log(PathReporter.report(result));
    // ThrowReporter.report(result);
  }
};

const CityTemplate = ({ data }: CityTemplateProp) => {
  runtimeTypChecker(data);

  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });

  const [
    selectedKnowMoreDetailsForMobile,
    setSelectedKnowMoreDetailsForMobile
  ] = useKnowMoreDetails(null, isMobileDevice);

  const delayedKnowMoreDetailsForMobile = async val => {
    await yeildToMainThread(() =>
      requestAnimationFrame(() => setSelectedKnowMoreDetailsForMobile(val))
    );
  };
  const [showAssistantIc, setShowAssistantIc] = useState(false);
  const [showWhatsAppIcon, setWhatsAppIcon] = useState(false);
  const [showCallUsIcon, setCallUsIcon] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const [shouldShowPackages, setShouldShowPackages] = useState(false);
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);

  const toggleOverlay = (isVisible: boolean) => {
    setIsOverlayVisible(isVisible);
  };

  const { travelFor, pickUpTime, dropTime } = useSearchWidgetHooks(
    SEO_CITY_TEMPLATE
  );

  const {
    packageData,
    allowRoundtrip,
    openDateWidget,
    openTripTypeAndThenDate,
    openTripType,
    packages,
    name,
    code,
    templateData,
    topRoutesfromCity,
    cabTypesAvailableForRent,
    topRoutesToCity,
    cabRentalPrices,
    description,
    description2HTML,
    hrPackages,
    assistedFormOpenDelay,
    showTripAssistantButton = false,
    showTripAssistantButtonForDweb = false,
    interlinks,
    showWhatsappWidget,
    whatsappWidgetDeeplink,
    customerCareNumber = '',
    assistantWidgetText = 'You can Call Us or Chat via WhatsApp',
    showWhatsAppForAssistedForm = false,
    showCallUsWidget = false,
    showCallUsForAssistedForm = false,
    aggregateRating,
    schemaMinFare,
    inboundCallText,
    inboundCallNumber,
    semCustomerCareNumber = '',
    semInboundCallNumber = '',
    showInboundCallNumberInDesktop = true,
    showCallusModalMweb = false,
    callusModalOpenDelay = 10000,
    showInboundNumberOnAssistedForm = false,
    couponInfo = null,
    showLeaveIntentForm = false,
    whatsappTooltipText,
    tripAssistanceToolTipText,
    intentCaptureEnabled,
    intentCaptureType
  } = data;

  let inboundCallNumberFinal = inboundCallNumber;
  let customerCareNumberFinal = customerCareNumber;
  if (isSEM()) {
    inboundCallNumberFinal = semInboundCallNumber;
    customerCareNumberFinal = semCustomerCareNumber;
  }

  const tooltipDelay = packageData?.tooltipInfo?.delay || 3000;

  const [showWhatsAppTooltip, setShowWhatsAppTooltip] = useState(
    !!whatsappTooltipText
  );
  const [showTripAssistantTooltip, setShowTripAssistantTooltip] = useState(
    !!tripAssistanceToolTipText
  );
  const useCityInTo = !!packageData;
  const scrollPosition = useRef(0);
  const assistedFormLifeCycle = useRef(0); // 0:init,1:scroll down to threshold, 2: scroll up to threshold, and automated modal shown

  const handleClose = () => {
    setIsBottomSheetOpen(false);
    // logRttEventLogger({omniUrlArgs:SEO_CITY_TEMPLATE, eventName: 'Cab_Packages_Bottom_Sheet_Closed', pageUrl: templateData.sampleUrl });

    trackCityTemplateEvent('Cab_Packages_Bottom_Sheet_Closed');
  };

  useEffect(() => {
    if (showWhatsAppTooltip) {
      setTimeout(() => {
        setShowWhatsAppTooltip(false);
      }, tooltipDelay);
    }
    if (showTripAssistantTooltip) {
      setTimeout(() => {
        setShowTripAssistantTooltip(false);
      }, tooltipDelay);
    }
  });

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowWhatsAppTooltip(true);
  //   }, 1000);

  //   return () => {
  //     clearTimeout(timer);
  //     setShowWhatsAppTooltip(false);
  //   };
  // }, []);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowTripAssistantTooltip(true);
  //   }, 1000);

  //   return () => {
  //     clearTimeout(timer);
  //     setShowTripAssistantTooltip(false);
  //   };
  // }, []);

  useEffect(() => {
    if (packageData && packageData?.show_delay) {
      const timer = setTimeout(() => {
        // const ModalOrSheetOpened = window.sessionStorage.getItem(
        //   'packageModalOrSheetOpened'
        // );
        // if (!ModalOrSheetOpened) {
        if (isMobile()) {
          //  logRttEventLogger({omniUrlArgs:`source=${SEO_CITY_TEMPLATE}`, eventName: 'Cab_Packages_Bottom_Sheet_Shown',pageUrl:templateData.sampleUrl });
          trackCityTemplateEvent('Cab_Packages_Bottom_Sheet_Shown');
          setIsBottomSheetOpen(packageData.show_bottom_sheet_mweb);
        } else {
          // logRttEventLogger({omniUrlArgs:`source=${SEO_CITY_TEMPLATE}`, eventName: 'Cab_Packages_Modal_Shown',pageUrl:templateData.sampleUrl });
          trackCityTemplateEvent('Cab_Packages_Modal_Shown');
          setShouldShowPackages(packageData.show_modal_dweb);
        }
        //   window.sessionStorage.setItem('packageModalOrSheetOpened', 'true');
        // }
      }, packageData.show_delay);

      return () => clearTimeout(timer);
    }
  }, [packageData]);

  const userActionDone = () => {
    return window?.localStorage?.getItem('userActionDone') == 'true';
  };

  const setShowModalWithDelay = async val => {
    if (
      isMobile()
        ? showCallusModalMweb || showTripAssistantButton
        : showTripAssistantButtonForDweb
    ) {
      await yeildToMainThread(() =>
        requestAnimationFrame(() => setShowModal(val))
      );
    }
  };
  const showModalConsideringScrollEvents = () => {
    if (assistedFormLifeCycle.current != 2 && !userActionDone()) {
      assistedFormLifeCycle.current = 2;
      setShowModalWithDelay(true);
      const eventName =
        showCallusModalMweb && showCallUsForAssistedForm && isMobile()
          ? 'Cab_SEO_Assisted_Call_Us_Form_Shown'
          : 'Cab_SEO_Assisted_Form_Shown';
      trackCityTemplateEvent(eventName);
    }
  };

  useEffect(() => {
    //
    const handleScroll = () => {
      scrollPosition.current = window.scrollY || window.pageYOffset;

      const scrollDownThreshold = isMobileDevice ? 500 : 900;
      const scrollUpThreshold = scrollDownThreshold - 100;

      if (
        scrollPosition.current > scrollDownThreshold &&
        assistedFormLifeCycle.current == 0
      ) {
        assistedFormLifeCycle.current = 1;
      } else if (
        scrollPosition.current < scrollUpThreshold &&
        assistedFormLifeCycle.current == 1
      ) {
        showModalConsideringScrollEvents();
      }
    };

    // If tripAssistantOpen is true in the query params then open form
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('tripAssistantOpen') === 'true') {
      showModalConsideringScrollEvents();
    }

    // Attach the scroll event listener
    window.addEventListener(SCROLL, handleScroll);
    if (window?.localStorage) {
      localStorage.removeItem(ASSISTED_FORM_DATA_LS);
    }

    openFormDueToInactivity();
    if (showCallUsWidget && isMobile()) {
      setTimeout(() => {
        trackCityTemplateEvent('Cab_SEO_Call_Us_Icon_Shown');
      }, 500);
    }
    if (intentCaptureEnabled) {
      setTimeout(() => {
        trackCityTemplateEvent(
          'Cab_SEO_Intent_Capture_Shown_' + intentCaptureEnabled
        );
      },2000);
    }

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener(SCROLL, handleScroll);
    };
  }, []);

  const openFormDueToInactivity = () => {
    const timeDelay = showCallusModalMweb
      ? callusModalOpenDelay
      : assistedFormOpenDelay;
    setTimeout(() => {
      if (window?.localStorage && assistedFormLifeCycle.current != 2) {
        if (
          !userActionDone() &&
          isMobile() &&
          (showTripAssistantButton || showCallusModalMweb)
        ) {
          showModalConsideringScrollEvents();
        } else {
          // not show message should not be shown if modal is already shown
          const userAction = userActionDone();
          trackCityTemplateEvent(
            `Cab_SEO_Assisted_Form_Not_Shown_userActionDone_${userAction}`
          );
        }
      }
    }, timeDelay);
  };

  useEffect(() => {
    window.addEventListener(SCROLL, listenToScroll);
    detectUserActivity();
    return () => window.removeEventListener(SCROLL, listenToScroll);
  }, []);

  const listenToScroll = () => {
    const heightToShowFrom = 100;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    if (winScroll > heightToShowFrom) {
      if (!(isMobileDevice && showModal)) {
        setShowAssistantIc(true);
        setWhatsAppIcon(true);
        setCallUsIcon(true);
      }
    } else {
      setShowAssistantIc(false);
      setWhatsAppIcon(false);
      setCallUsIcon(false);
    }
  };

  const fabInteraction = () => {
    return (
      <div
        className={` ${(() => {
          if (showTripAssistantButtonForDweb && showTripAssistantButton) {
            return '';
          } else if (showTripAssistantButton) {
            return 'mobileShow';
          } else if (showTripAssistantButtonForDweb) {
            return 'desktopShow';
          }
          return '';
        })()}`}
      >
        <div
          onClick={() => {
            trackCityTemplateEvent(
              `${
                showModal
                  ? 'Cab_SEO_Assisted_Form_Closed'
                  : 'Cab_SEO_Assisted_Form_CTA_Click'
              }`
            );
            setShowModalWithDelay(!showModal);
            assistedFormLifeCycle.current = 2; // keeping this 2 as for both the cases Closed and Clicked, Assisted form will be shown
          }}
          className={`fabInteraction ${
            showModal && isMobileDevice
              ? 'showCrossIc'
              : showAssistantIc
              ? 'showIc'
              : ''
          }`}
        >
          <div className={`icContainer ${showModal ? 'showCrossIc' : ''}`} />
          {true && <span>Trip Assistant</span>}
        </div>
      </div>
    );
  };

  const callUsForm = () => {
    return (
      <div
        className={` ${(() => {
          if (showCallusModalMweb) {
            return '';
          }
          return '';
        })()}`}
      >
        <div
          onClick={() => {
            trackCityTemplateEvent(
              `${
                showModal
                  ? 'Cab_SEO_Assisted_Call_Us_Form_Closed'
                  : 'Cab_SEO_Assisted_Form_CTA_Click'
              }`
            );
            setShowModalWithDelay(!showModal);
            assistedFormLifeCycle.current = 2; // keeping this 2 as for both the cases Closed and Clicked, Assisted form will be shown
          }}
          className={`${
            showModal && isMobileDevice
              ? 'fabInteraction showCrossIc'
              : showAssistantIc
              ? 'showIc'
              : ''
          }`}
        >
          <div className={`icContainer ${showModal ? 'showCrossIc' : ''}`} />
        </div>
      </div>
    );
  };

  const handleWhatsappWidget = () => {
    onWhatsAppIconClick();
    trackCityTemplateEvent('Cab_SEO_WhatsApp_Assisted_Icon_Clicked');
    setShowWhatsAppTooltip(false);
  };

  const onWhatsAppIconClick = () => {
    const requestId = generateRequestId();
    const pageName = 'seo_city_page';
    makeServiceDeskRequest(requestId, pageName);
    const whatsAppChatLinkWithRequestId = whatsappWidgetDeeplink
      ? whatsappWidgetDeeplink.replace('MDRequest_id', requestId)
      : '';
    if (whatsAppChatLinkWithRequestId)
      window.location.href = whatsAppChatLinkWithRequestId;
  };

  const handleTooltipClose = e => {
    e.stopPropagation();
    setShowWhatsAppTooltip(false);
  };
  const onCallUsIconClick = () => {
    window.open(`tel:${customerCareNumberFinal}`, '_blank');
  };

  return (
    <AppContextProvider
      omniUrlArgs={`source=${SEO_CITY_TEMPLATE}`}
      trackTemplateEvent={trackCityTemplateEvent}
      selectedKnowMoreDetailsForMobile={selectedKnowMoreDetailsForMobile}
      setSelectedKnowMoreDetailsForMobile={delayedKnowMoreDetailsForMobile}
    >
      <div>
        {isMobile() && showWhatsappWidget && (
          <div className="whatsapp-wrapper">
            {showWhatsAppTooltip && (
              <div className="whatsapp-tooltip">
                <span className="whatsapp-tooltip-text">
                  {packageData?.tooltipInfo?.text || 'Chat with us on WhatsApp'}
                </span>
                <img
                  onClick={handleTooltipClose}
                  src={`${PUBLIC_URL}/static/public/cross_white_icon.png`}
                  alt="close"
                  className="whatsapp-tooltip-close"
                />
              </div>
            )}
            <div
              className={`${!showModal ? 'whatsApp' : ''} ${
                showModal ? '' : showWhatsAppIcon ? 'showWhatsAppIcon' : ''
              }`}
              onClick={handleWhatsappWidget}
            >
              <div
                className={`${!showModal ? 'whatsaAppIconContainer' : ''}`}
              />
              {true && !showModal && <span>Chat with us</span>}
            </div>
          </div>
        )}
      </div>
      <div>
        {isMobile() && showCallUsWidget && customerCareNumberFinal && (
          <div
            className={`${!showModal ? 'callUs' : ''} ${
              showModal ? '' : showCallUsIcon ? 'showCallUsIcon' : ''
            }`}
            onClick={() => {
              onCallUsIconClick();
              trackCityTemplateEvent('Cab_SEO_Call_Us_Icon_Clicked');
            }}
          >
            <div className={`${!showModal ? 'callUsIconContainer' : ''}`} />
            {true && !showModal && <span>Call us now</span>}
          </div>
        )}
      </div>
      {isMobile() && showTripAssistantButton ? fabInteraction() : <div></div>}
      {showCallusModalMweb && callUsForm()}
      {(showTripAssistantButtonForDweb || showLeaveIntentForm) &&
      !isMobile() ? (
        <div className="tripAssistant">
          {showTripAssistantTooltip && (
            <div className="tripassistant-tooltip">
              <span className="tripassistant-tooltip-text">
                {packageData?.tooltipInfo?.text}
              </span>
              <img
                onClick={e => {
                  e.stopPropagation();
                  setShowTripAssistantTooltip(false);
                }}
                src={`${PUBLIC_URL}/static/public/cross_white_icon.png`}
                alt="close"
                className="tripassistant-tooltip-close"
              />
            </div>
          )}
        </div>
      ) : (
        <div className="tripAssistant"></div>
      )}
      {(showTripAssistantButtonForDweb || showLeaveIntentForm) &&
      !isMobile() ? (
        <div className="tripAssistant2">
          <TripAssistant
            trackEvent={trackCityTemplateEvent}
            source={name}
            hideForm={false}
            customerCareNumber={inboundCallNumberFinal}
            autoOpenDelay={assistedFormOpenDelay}
            couponData={couponInfo}
            showTripAssistant={showTripAssistantButtonForDweb}
            showLeaveIntentForm={showLeaveIntentForm}
          />
        </div>
      ) : (
        <div className="tripAssistant2"></div>
      )}

      {showModal && isMobile() && showTripAssistantButton && (
        <AssistModal
          sourceCity={name}
          setShowModal={val => setShowModalWithDelay(val)}
          trackTemplateEvent={trackCityTemplateEvent}
          showWhatsAppForAssistedForm={showWhatsAppForAssistedForm}
          showCallUsForAssistedForm={showCallUsForAssistedForm}
          customerCareNumber={customerCareNumberFinal}
          assistantWidgetText={assistantWidgetText}
          onCallUsIconClick={onCallUsIconClick}
          onWhatsAppIconClick={onWhatsAppIconClick}
          showInboundNumberOnAssistedForm={showInboundNumberOnAssistedForm}
          inboundCallNumber={inboundCallNumberFinal}
          inboundCallText={inboundCallText}
        />
      )}
      {showModal && isMobile() && showCallusModalMweb && (
        <CallUsModal
          setShowModal={val => setShowModalWithDelay(val)}
          trackTemplateEvent={trackCityTemplateEvent}
          showWhatsAppForAssistedForm={showWhatsAppForAssistedForm}
          showCallUsForAssistedForm={showCallUsForAssistedForm}
          customerCareNumber={customerCareNumberFinal}
          assistantWidgetText={assistantWidgetText}
          onCallUsIconClick={onCallUsIconClick}
          onWhatsAppIconClick={onWhatsAppIconClick}
          showModal={showModal}
        />
      )}
      {packageData && isMobile() && isBottomSheetOpen && !userActionDone() ? (
        <PackagesBottomSheet
          packageData={packageData}
          onClose={handleClose}
          pageUrl={templateData.sampleUrl}
        />
      ) : null}
      {packageData && !isMobile() && shouldShowPackages && !userActionDone() && (
        <PackagesModal
          pageUrl={templateData.sampleUrl}
          packageData={packageData}
          onClose={() => {
            setShouldShowPackages(false);
            // logRttEventLogger({omniUrlArgs:`source=${SEO_CITY_TEMPLATE}`, eventName: 'Cab_Packages_Modal_Closed',pageUrl: templateData.sampleUrl });
            trackCityTemplateEvent('Cab_Packages_Modal_Closed');
          }}
          show={true}
        />
      )}
      <div
        className={`cabSeoDtPage ${
          selectedKnowMoreDetailsForMobile ? 'expanded' : ''
        }`}
      >
        <Helmet>
          <title>{templateData.metaTitle}</title>
          <meta name="description" content={templateData.metaDescription} />
          <meta name="keywords" content={templateData.metaKeywords} />
          <link rel="canonical" href={templateData.sampleUrl} />
          {templateData.ogTitle && (
              <meta property="og:title" content={templateData.ogTitle} />
            )}
            {templateData.ogDescription && (
              <meta
                property="og:description"
                content={templateData.ogDescription}
              />
            )}
            {templateData.ogImage && (
              <meta name="og:image" content={templateData.ogImage} />
            )}
            {templateData.twitterTitle && (
              <meta name="twitter:title" content={templateData.twitterTitle} />
            )}
            {templateData.twitterDescription && (
              <meta
                name="twitter:description"
                content={templateData.twitterDescription}
              />
            )}
            {templateData.twitterImage && (
              <meta name="twitter:image" content={templateData.twitterImage} />
            )}
        </Helmet>
        {aggregateRating && (
          <ProductSchema
            data={aggregateRating}
            templateData={templateData}
            schemaMinFare={schemaMinFare}
            source={name}
          />
        )}
        <div className={`domChanger mobileShow makeSticky`}>
          <CabModifySearch
            intentCaptureType={intentCaptureType}
            isOverlayVisible={isOverlayVisible}
            overlayToggle={toggleOverlay}
            openTripTypeAndThenDate={openTripTypeAndThenDate}
            openDateWidget={openDateWidget}
            openTripType={openTripType}
            pickupTime={pickUpTime}
            defaultTripType={allowRoundtrip ? OUTSTATION_ROUND_TRIP : travelFor}
            returnTime={dropTime}
            sourceCityCode={useCityInTo ? undefined : code}
            sourceCityName={useCityInTo ? undefined : name}
            destinationCityCode={useCityInTo ? code : undefined}
            destinationCityName={useCityInTo ? code : undefined}
            isMobileDevice={true}
            title={`${name} Cabs`}
            hrPackages={hrPackages}
          />
        </div>
        <div className={`desktopShow makeSticky`}>
          <CabModifySearch
            intentCaptureType={intentCaptureType}
            openDateWidget={openDateWidget}
            openTripType={openTripType}
            pickupTime={pickUpTime}
            openTripTypeAndThenDate={openTripTypeAndThenDate}
            defaultTripType={allowRoundtrip ? OUTSTATION_ROUND_TRIP : travelFor}
            returnTime={dropTime}
            sourceCityCode={useCityInTo ? undefined : code}
            sourceCityName={useCityInTo ? undefined : name}
            destinationCityCode={useCityInTo ? code : undefined}
            destinationCityName={useCityInTo ? code : undefined}
            returnCloseFlagDefault={false}
            isMobileDevice={false}
            title={`${name} Cabs`}
            hrPackages={hrPackages}
          />
        </div>
        <main className={`container `}>
          <div className="makeFlex">
            <BreadCrumb breadcrumb={templateData.breadcrumb} />
            {showInboundCallNumberInDesktop ? (
              <InboundCallBox
                inboundCallText={inboundCallText}
                inboundCallNumber={inboundCallNumberFinal}
              />
            ) : (
              <div></div>
            )}
          </div>
          <PageHeader
            title={templateData.h1Title}
            extraInfo={templateData.extraInfo}
            isMobileDevice={isMobileDevice}
          />
          {/* <div className="appendBottom20">
            {
              <AdsComponent
                template={'City'}
                placedAt={'top'}
                isMobileDevice={isMobileDevice}
                desktopAdConfig={{
                  position: templateData.bannerDesktop
                    ? templateData.bannerDesktop
                    : 'none',
                  class: 'desktopShow appendBottom20 adsLayout',
                  style: {}
                }}
                mobileAdConfig={{
                  position: templateData.bannerMobile
                    ? templateData.bannerMobile
                    : 'none',
                  class: 'mobileShow appendBottom20 adsLayout',
                  style: { marginTop: null }
                }}
              />
            }
          </div> */}
          {packageData && (
            <PackageBanner
              packageData={packageData}
              pageUrl={templateData.sampleUrl}
            />
          )}
          {packages && packages.length > 0 ? (
            <div>
              <h2 className="blackText">{`Popular packages in ${name}`}</h2>
              <br />
              <MultiCityPackages
                removeLeftRightPadding={true}
                packages={packages}
                disableStopFilter={true}
                disableCabCardImage={true}
                stopType={'City'}
              />
            </div>
          ) : null}
          {topRoutesfromCity.cabTypes.length > 0 && (
            <TopCabsRoutes
              h2={`Top ${
                allowRoundtrip ? 'Round Trip ' : ''
              }Cabs Routes from ${name}`}
              cityName={name}
              routeType="From"
              data={topRoutesfromCity}
              enableAnchorTags={true}
              reduceCssCalculations={false}
            />
          )}
          {topRoutesToCity.cabTypes.length > 0 && (
            <TopCabsRoutes
              h2={`Top ${
                allowRoundtrip ? 'Round Trip ' : ''
              }Cabs Routes to ${name}`}
              cityName={name}
              routeType="To"
              data={topRoutesToCity}
              enableAnchorTags={true}
            />
          )}
          {templateData.usps.length > 0 && (
            <section className="bookWithUsWrap visibilityAuto">
              <h2>Why book with Us</h2>
              <WhyBookWithUs usps={templateData.usps} />
            </section>
          )}
          {cabTypesAvailableForRent &&
            cabTypesAvailableForRent.packages &&
            cabTypesAvailableForRent.packages.length > 0 && (
              <RentalCabs
                h2={`Rental cabs in ${name}`}
                cityName={name}
                data={cabTypesAvailableForRent}
              />
            )}
          {/*https://github.com/contra/react-responsive/issues/162*/}

          {/* {mySafetyHtmls.ePassUsp && (
            <div className=" appendBottom40">
              <EpassBnr html={mySafetyHtmls.ePassUsp} />
            </div>
          )}
          <br style={{ display: 'none' }} />

          {mySafetyHtmls.stateGuidelines && (
            <section>
              <h2>State Guidelines on e-Passes</h2>
              <StateGuidelines html={mySafetyHtmls.stateGuidelines} />
            </section>
          )} */}
          {templateData.descriptionInHtml ? (
            <section id="descriptionInHtml" className="visibilityAuto">
              <ThingsToKnow html={templateData.descriptionInHtml} />
            </section>
          ) : null}
          {description2HTML && (
            <section className="visibilityAuto">
              <h2>{`${name} Cab Booking on MMT`}</h2>
              <ThingsToKnow html={description2HTML} />
            </section>
          )}
          {description && (
            <section className="visibilityAuto">
              <h2>{`Things To Know About ${name}`}</h2>
              <ThingsToKnow text1={description} />
            </section>
          )}
          <section className="visibilityAuto">
            <h2>{`Frequently Asked Questions About ${name} Cab Booking`}</h2>
            <FaqSection
              trackTemplateEvent={trackCityTemplateEvent}
              data={templateData.faq}
              pageUrl={templateData.sampleUrl}
            />
          </section>
          {cabRentalPrices && cabRentalPrices.length > 0 ? (
            <section className="visibilityAuto">
              <h2>{`${name} Rental Cabs Prices`}</h2>
              <RentalCabPrice cabRentalPrices={cabRentalPrices} />
            </section>
          ) : null}
          <div
            style={{ flexWrap: 'wrap' }}
            className={`cabsSeoWrap__Details makeFlex visibilityAuto`}
          >
            {interlinks &&
              interlinks.map(({ title, links }) => {
                return (
                  <CompactList
                    titlePrefix={title}
                    titleSuffix={``}
                    list={links}
                    type={'bullets'}
                    className={'rightMargin'}
                  >
                    {(item: any, idx, style) => (
                      <li
                        key={`${item.text}_${idx}`}
                        className={`${
                          idx ? `paddingT10 paddingB10` : `paddingB10`
                        }`}
                      >
                        {item.url ? (
                          <a
                            className={`linkBoxFont `}
                            onClick={() => {
                              //TO DO: add omniture events from Dataloader
                            }}
                            href={item.url}
                          >
                            {item.text}
                          </a>
                        ) : (
                          <span>{item.text}</span>
                        )}
                      </li>
                    )}
                  </CompactList>
                );
              })}
          </div>
        </main>
        {selectedKnowMoreDetailsForMobile ? (
          <Overlay
            cancelButton={() => delayedKnowMoreDetailsForMobile(null)}
            knowMoreDetails={selectedKnowMoreDetailsForMobile}
          />
        ) : null}
        <Footer template={templateData} />
        <div
          className="blackOverlay"
          onClick={() => {
            delayedKnowMoreDetailsForMobile(null);
          }}
        ></div>
        {isOverlayVisible && (
          <div
            onClick={() => {
              toggleOverlay(false);
            }}
            className="searchWidgetModal mobileShow"
          ></div>
        )}
      </div>
    </AppContextProvider>
  );
};

CityTemplate.fetchData = async (_, match, urlObj) => {
  const {
    params: { cityCode }
  } = match;
  const url = `${DATA_LOADER_URL}/api/cityTemplateData/${cityCode}?${urlObj.query}`;
  let responseData;

  const response = await fetch(url);
  const textResponse = await response.text();

  try {
    responseData = JSON.parse(textResponse);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('url', url);
    throw new Error('JSON parse exception: ' + textResponse);
  }
  if (responseData.status !== 'SUCCESS') {
    // eslint-disable-next-line no-console
    console.error('url', url);
    throw new DataLoaderError(
      `Unable to fetch city details of ${cityCode}`,
      responseData.error
    );
  }
  return responseData;
};
export default CityTemplate;
